/**
 * SEO Configuration and Helpers for SENKAY Personal und Logistik
 */

export const siteMetadata = {
  title: 'SENKAY Personal und Logistik | Professionelle Personaldienstleistungen München',
  description: 'SENKAY bietet verlässliche Personal- und Logistiklösungen in München, Bayern und der DACH-Region. Gebäudemanagement, Personalverleih, Eventpersonal, Messe-Auf/Abbau und mehr.',
  siteUrl: 'https://senkay.de', // TODO: Update with actual domain
  companyName: 'SENKAY Personal und Logistik',
  keywords: [
    'Personalverleih München',
    'Eventpersonal München',
    'Gebäudemanagement Bayern',
    'Bauendreinigung München',
    'Arbeitnehmerüberlassung München',
    'Messe Aufbau München',
    'Hostessen Service München',
    'Kellner Verleih München',
    'Personal Logistik Bayern',
    'Öffentliche Ausschreibungen Personal'
  ],
  author: 'SENKAY Personal und Logistik',
  social: {
    linkedin: '',
    facebook: '',
    instagram: '',
  },
  contact: {
    phone: '+49 89 XXXXXXXX', // TODO: Add real phone
    email: 'kontakt@senkay.de', // TODO: Add real email
    address: {
      street: 'Musterstraße 123',
      city: 'München',
      zip: '80331',
      country: 'Deutschland'
    }
  }
};

/**
 * Generate structured data (JSON-LD) for local business
 */
export function generateLocalBusinessSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': siteMetadata.siteUrl,
    name: siteMetadata.companyName,
    description: siteMetadata.description,
    url: siteMetadata.siteUrl,
    telephone: siteMetadata.contact.phone,
    email: siteMetadata.contact.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteMetadata.contact.address.street,
      addressLocality: siteMetadata.contact.address.city,
      postalCode: siteMetadata.contact.address.zip,
      addressCountry: siteMetadata.contact.address.country
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '48.1351', // München coordinates
      longitude: '11.5820'
    },
    areaServed: [
      {
        '@type': 'City',
        name: 'München'
      },
      {
        '@type': 'State',
        name: 'Bayern'
      },
      {
        '@type': 'Country',
        name: 'Deutschland'
      }
    ],
    priceRange: '€€',
    openingHours: 'Mo-Fr 08:00-18:00'
  };
}

/**
 * Generate breadcrumb schema
 */
export function generateBreadcrumbSchema(items) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url ? `${siteMetadata.siteUrl}${item.url}` : undefined
    }))
  };
}

/**
 * Generate service schema
 */
export function generateServiceSchema(service) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: service.name,
    provider: {
      '@type': 'LocalBusiness',
      name: siteMetadata.companyName
    },
    description: service.description,
    areaServed: {
      '@type': 'City',
      name: 'München'
    }
  };
}

/**
 * Page-specific meta configurations
 */
export const pageMeta = {
  home: {
    title: 'SENKAY Personal und Logistik | Professionelle Personaldienstleistungen München',
    description: 'SENKAY bietet verlässliche Personal- und Logistiklösungen in München, Bayern und der DACH-Region. Schnell, skalierbar und rechtssicher.',
    keywords: 'Personalverleih München, Eventpersonal, Gebäudemanagement Bayern'
  },
  services: {
    title: 'Unsere Leistungen | SENKAY Personal und Logistik',
    description: 'Entdecken Sie unser umfassendes Leistungsportfolio: Gebäudemanagement, Personalüberlassung, Event-Services, Bauendreinigung und mehr.',
    keywords: 'Personaldienstleistungen, Gebäudemanagement, Event-Services München'
  },
  about: {
    title: 'Über uns | SENKAY Personal und Logistik',
    description: 'Erfahren Sie mehr über SENKAY - Ihr zuverlässiger Partner für Personal- und Logistiklösungen in München und Bayern.',
    keywords: 'SENKAY, Personaldienstleister München, Über uns'
  },
  contact: {
    title: 'Kontakt | SENKAY Personal und Logistik',
    description: 'Nehmen Sie Kontakt mit SENKAY auf. Wir beraten Sie gerne zu Ihrem Personalbedarf und erstellen ein individuelles Angebot.',
    keywords: 'Kontakt SENKAY, Angebot anfordern, Personalberatung München'
  },
  privacy: {
    title: 'Datenschutzerklärung | SENKAY Personal und Logistik',
    description: 'Datenschutzerklärung von SENKAY Personal und Logistik',
    keywords: 'Datenschutz, DSGVO'
  },
  imprint: {
    title: 'Impressum | SENKAY Personal und Logistik',
    description: 'Impressum von SENKAY Personal und Logistik',
    keywords: 'Impressum, Kontaktdaten'
  }
};
